module.exports = __webpack_public_path__ + "static/media/Aeonik-Light.7cb8fc10.woff2";